import { createSelector } from 'reselect'

export const selectSmsLongCode = state => state.clientEvents.smsLongCode
export const selectDigestViewEvents = state => state.clientEvents.digestViewEvents

export const selectIsFirstDigestView = createSelector(
  selectDigestViewEvents,
  events => Array.isArray(events) && events.length === 0
)
